export const initializer = `
{
  const Object = options.Object;
  const getNumberFromString = options.getNumberFromString;
}
`;
//# sourceMappingURL=initializer.js.map